import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png';

const VIDEOS = [
  { file: '3D Anamorphic Wall.mp4',                          title: '3D Anamorphic Wall' },
  { file: '4D Immersive Experience Room.mp4',                 title: '4D Immersive Experience Room' },
  { file: 'Ar 3D Table.mp4',                                  title: 'AR 3D Table' },
  { file: 'AR Based Model Scanner with Display.mp4',          title: 'AR Based Model Scanner with Display' },
  { file: 'Big Switch- Product Zone.mp4',                     title: 'Big Switch – Product Zone' },
  { file: 'Circular_Touch_Display_V1.mp4',                    title: 'Circular Touch Display' },
  { file: 'Holobox.mp4',                                      title: 'Holobox' },
  { file: 'Interactaive circular rotoscope.mp4',               title: 'Interactive Circular Rotoscope' },
  { file: 'Interactaive oled with 3d model.mp4',               title: 'Interactive OLED with 3D Model' },
  { file: 'Interactive Holobox.mp4',                          title: 'Interactive Holobox' },
  { file: 'Interactive Projection Sphere v1.mp4',              title: 'Interactive Projection Sphere' },
  { file: 'Interactive Quiz - FUN SPOT.mp4',                  title: 'Interactive Quiz – Fun Spot' },
  { file: 'Interactive Seamless Cube.mp4',                    title: 'Interactive Seamless Cube' },
  { file: 'Interactive Sphere.mp4',                           title: 'Interactive Sphere' },
  { file: 'Interactive Walkthrough.mp4',                      title: 'Interactive Walkthrough' },
  { file: 'Kinetic  Pixel.mp4',                               title: 'Kinetic Pixel' },
  { file: 'Kinetic  Rotating  Wall.mp4',                      title: 'Kinetic Rotating Wall' },
  { file: 'Kinetic Rotating Pillar.mp4',                      title: 'Kinetic Rotating Pillar' },
  { file: 'Led Cube.mp4',                                     title: 'LED Cube' },
  { file: 'Luminous Experience Center.mp4',                   title: 'Luminous Experience Center' },
  { file: 'Object Recognition Table.mp4',                     title: 'Object Recognition Table' },
  { file: 'Oled wall with 3d model.mp4',                      title: 'OLED Wall with 3D Model' },
  { file: 'Pick & Learn - Interactive Display.mp4',           title: 'Pick & Learn – Interactive Display' },
  { file: 'RFID Based Content Wall Display.mp4',              title: 'RFID Based Content Wall Display' },
  { file: 'Rfid Pod.mp4',                                     title: 'RFID Pod' },
  { file: 'robo symphony.mp4',                                title: 'Robo Symphony' },
  { file: 'Smart Interactive Table with LED Display.mp4',     title: 'Smart Interactive Table with LED Display' },
  { file: 'Tech Installation- VIA Mall, Riyadh.mp4',          title: 'Tech Installation – VIA Mall, Riyadh' },
  { file: 'Transparent  Oled.mp4',                            title: 'Transparent OLED' },
  { file: 'Waves.mp4',                                        title: 'Waves' },
];

function VideoCard({ video, index, onClick }) {
  const [hov, setHov] = useState(false);
  const src = `https://chalkwalkconsulting.com/Tech/Tech/${encodeURIComponent(video.file)}`;

  return (
    <div
      onClick={() => onClick(index)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: '#fff',
        borderRadius: 16,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `1px solid ${hov ? '#d4cfc8' : '#ede9e3'}`,
        boxShadow: hov ? '0 12px 32px rgba(0,0,0,0.10)' : '0 2px 8px rgba(0,0,0,0.04)',
        transform: hov ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'all 0.25s ease',
      }}
    >
      {/* Thumbnail */}
      <div style={{ position: 'relative', aspectRatio: '16/9', background: '#f0ede8', overflow: 'hidden' }}>
        <video
          src={src}
          preload="metadata"
          muted
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />

        {/* Hover overlay */}
        <div
          style={{
            position: 'absolute', inset: 0,
            background: hov ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.08)',
            transition: 'background 0.25s ease',
          }}
        />

        {/* Play button */}
        <div
          style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            opacity: hov ? 1 : 0.7,
            transition: 'opacity 0.25s ease',
          }}
        >
          <div
            style={{
              width: hov ? 52 : 44,
              height: hov ? 52 : 44,
              borderRadius: '50%',
              background: hov ? '#fff' : 'rgba(255,255,255,0.85)',
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.25s ease',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a1a1a">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>

        {/* Index badge */}
        <div
          style={{
            position: 'absolute', top: 10, left: 12,
            background: 'rgba(255,255,255,0.88)',
            backdropFilter: 'blur(6px)',
            borderRadius: 20, padding: '2px 9px',
            fontSize: 10, color: '#666',
            letterSpacing: 1.5, fontWeight: 600,
          }}
        >
          {String(index + 1).padStart(2, '0')}
        </div>
      </div>

      {/* Title */}
      <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: 'DM Serif Display', fontSize: 15, color: '#1a1a1a', lineHeight: 1.4 }}>
          {video.title}
        </div>
        <div
          style={{
            width: 28, height: 28, borderRadius: '50%',
            background: hov ? '#f0ede8' : 'transparent',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, transition: 'background 0.2s',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={hov ? '#1a1a1a' : '#bbb'} strokeWidth="2.5" style={{ transition: 'stroke 0.2s' }}>
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function VideoLightbox({ index, onClose, onPrev, onNext }) {
  const video = VIDEOS[index];
  const src = `https://chalkwalkconsulting.com/Tech/Tech/${encodeURIComponent(video.file)}`;
  const videoRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    if (videoRef.current) videoRef.current.load();
  }, [index]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(26,26,26,0.85)',
        backdropFilter: 'blur(10px)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '2rem',
        animation: 'fadeIn 0.2s ease',
      }}
    >
      {/* Modal panel */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: 20,
          overflow: 'hidden',
          width: '100%', maxWidth: 900,
          boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
        }}
      >
        {/* Modal header */}
        <div
          style={{
            padding: '18px 24px',
            borderBottom: '1px solid #ede9e3',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}
        >
          <div style={{ fontFamily: 'DM Serif Display', fontSize: 18, color: '#1a1a1a' }}>
            {video.title}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ fontSize: 12, color: '#aaa' }}>
              {index + 1} / {VIDEOS.length}
            </div>
            <button
              onClick={onClose}
              style={{
                background: '#f5f3f0', border: '1px solid #e8e4e0',
                borderRadius: '50%', width: 32, height: 32,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 16, color: '#666', cursor: 'pointer',
              }}
            >
              ×
            </button>
          </div>
        </div>

        {/* Video */}
        <div style={{ background: '#1a1a1a' }}>
          <video
            ref={videoRef}
            src={src}
            controls
            autoPlay
            preload="auto"
            style={{ width: '100%', display: 'block', maxHeight: '65vh' }}
          />
        </div>

        {/* Modal footer — prev / next */}
        <div
          style={{
            padding: '14px 24px',
            borderTop: '1px solid #ede9e3',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}
        >
          <button
            onClick={onPrev}
            disabled={index === 0}
            style={{
              background: index === 0 ? 'transparent' : '#f5f3f0',
              border: '1px solid #e8e4e0',
              borderRadius: 8, padding: '7px 18px',
              fontSize: 13, color: index === 0 ? '#ccc' : '#444',
              cursor: index === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            ← Prev
          </button>

          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', maxWidth: 400, justifyContent: 'center' }}>
            {VIDEOS.map((_, i) => (
              <div
                key={i}
                style={{
                  width: i === index ? 20 : 6,
                  height: 6, borderRadius: 3,
                  background: i === index ? '#1a1a1a' : '#e8e4e0',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (i < index) onPrev();
                  else if (i > index) onNext();
                }}
              />
            ))}
          </div>

          <button
            onClick={onNext}
            disabled={index === VIDEOS.length - 1}
            style={{
              background: index === VIDEOS.length - 1 ? 'transparent' : '#1a1a1a',
              border: index === VIDEOS.length - 1 ? '1px solid #e8e4e0' : 'none',
              borderRadius: 8, padding: '7px 18px',
              fontSize: 13, color: index === VIDEOS.length - 1 ? '#ccc' : '#fff',
              cursor: index === VIDEOS.length - 1 ? 'not-allowed' : 'pointer',
            }}
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
}

function TechPage({ onBack, user, onLogout }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const initials = user.name.slice(0, 2).toUpperCase();

  return (
    <div style={{ minHeight: '100vh', background: '#F7F5F2' }}>

      {/* ── Header — identical to other pages ── */}
      <header
        style={{
          background: '#fff',
          borderBottom: '1px solid #ede9e3',
          padding: '0 2.5rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          height: 116, position: 'sticky', top: 0, zIndex: 100,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="ChalkWalk Design Studio" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <button
            onClick={onBack}
            style={{ background: '#f5f3f0', border: '1px solid #e8e4e0', borderRadius: 8, padding: '6px 16px', fontSize: 13, color: '#666', cursor: 'pointer' }}
          >
            ← Back to Planner
          </button>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{user.name}</div>
            <div style={{ fontSize: 11, color: '#aaa' }}>{user.email}</div>
          </div>
          <div
            style={{
              width: 36, height: 36, background: '#5B4FCF', borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 600, color: '#fff',
            }}
          >
            {initials}
          </div>
          <button
            onClick={onLogout}
            style={{ background: '#f5f3f0', border: '1px solid #e8e4e0', borderRadius: 8, padding: '6px 14px', fontSize: 12, color: '#666', cursor: 'pointer' }}
          >
            Sign Out
          </button>
        </div>
      </header>

      {/* ── Main ── */}
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '2.5rem 2rem' }}>

        {/* Page title */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h1 style={{ fontFamily: 'DM Serif Display', fontSize: 36, color: '#1a1a1a', marginBottom: 6 }}>
            Tech Installations
          </h1>
          <p style={{ color: '#888', fontSize: 14 }}>
            {VIDEOS.length} interactive technology installation{VIDEOS.length !== 1 ? 's' : ''} from ChalkWalk Design Studio
          </p>
        </div>

        {/* Video grid */}
        <div
          className="fade-in"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 20,
          }}
        >
          {VIDEOS.map((v, i) => (
            <VideoCard key={v.file} video={v} index={i} onClick={setActiveIndex} />
          ))}
        </div>
      </main>

      {/* ── Lightbox ── */}
      {activeIndex !== null && (
        <VideoLightbox
          index={activeIndex}
          onClose={() => setActiveIndex(null)}
          onPrev={() => setActiveIndex(i => Math.max(0, i - 1))}
          onNext={() => setActiveIndex(i => Math.min(VIDEOS.length - 1, i + 1))}
        />
      )}
    </div>
  );
}

export default TechPage;
